import * as React from "react"

import { SortButton, SortPanel, type SortOption } from "@/components/ui/table-sort"
import { type TableSort } from "@/lib/table"

const OPTIONS: SortOption[] = [
  { id: "updatedAt", label: "Last updated", ascLabel: "Oldest first", descLabel: "Newest first" },
  { id: "name", label: "Name", ascLabel: "A → Z", descLabel: "Z → A" },
  { id: "count", label: "Item count", ascLabel: "Fewest first", descLabel: "Most first" },
]

export function TableSortPreviewRoute(): JSX.Element {
  const [sort, setSort] = React.useState<TableSort | null>({ field: "updatedAt", dir: "desc" })
  const [panelSort, setPanelSort] = React.useState<TableSort | null>(null)

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Sort</h1>
        <p className="mt-2 max-w-2xl text-body text-text-2">
          Generic sort trigger + panel. Sibling to <code>FilterButton</code> — any table screen
          drops in a schema of sortable options.
        </p>
      </header>

      <Section title="SortButton (trigger + panel)">
        <SortButton options={OPTIONS} value={sort} onChange={setSort} />
        <p className="text-caption text-text-3">
          Value:{" "}
          <span className="font-id text-text">{sort ? `${sort.field} · ${sort.dir}` : "—"}</span>
        </p>
      </Section>

      <Section title="SortPanel (bare, always open)">
        <div className="w-[260px] rounded-lg border border-border bg-surface">
          <SortPanel
            options={OPTIONS}
            value={panelSort}
            onChange={setPanelSort}
            onClose={() => undefined}
          />
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-start gap-4">{children}</div>
    </section>
  )
}
